<template>
	<svg :width="width" :height="height" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<g>
			<rect fill="none" stroke-miterlimit="10" stroke-width="1.91px" :stroke="color" x="2.45" y="13.91" width="19.09" height="8.59"></rect>
			<line fill="none" stroke-miterlimit="10" stroke-width="1.91px" :stroke="color" x1="23.45" y1="13.91" x2="0.55" y2="13.91"></line>
			<line fill="none" stroke-miterlimit="10" stroke-width="1.91px" :stroke="color" x1="7.23" y1="13.91" x2="7.23" y2="22.5"></line>
			<line fill="none" stroke-miterlimit="10" stroke-width="1.91px" :stroke="color" x1="12" y1="13.91" x2="12" y2="22.5"></line>
			<line fill="none" stroke-miterlimit="10" stroke-width="1.91px" :stroke="color" x1="16.77" y1="13.91" x2="16.77" y2="22.5"></line>
			<path fill="none" stroke-miterlimit="10" stroke-width="1.91px" :stroke="color" d="M6.27,12V7.23A5.73,5.73,0,0,1,12,1.5h0a5.73,5.73,0,0,1,5.73,5.73V12"></path>
			<line fill="none" stroke-miterlimit="10" stroke-width="1.91px" :stroke="color" x1="6.27" y1="8.18" x2="18.68" y2="8.18"></line>
			<line fill="none" stroke-miterlimit="10" stroke-width="1.91px" :stroke="color" x1="12" y1="1.5" x2="12" y2="12"></line>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'BalconyIcon',
	props: {
		width: {
			type: Number,
			default: 32,
		},
		height: {
			type: Number,
			default: 32,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
}
</script>
